export default __webpack_public_path__ + "static/media/servicios_1.05983189.jpg";